import script from "./AccessoriesDialog.vue?vue&type=script&lang=ts&setup=true"
export * from "./AccessoriesDialog.vue?vue&type=script&lang=ts&setup=true"

import "./AccessoriesDialog.vue?vue&type=style&index=0&id=3d079ac0&lang=scss"

const __exports__ = script;

export default __exports__